<template>
  <div id="profile" v-bind:class="{ 'margin-small': !appIsActive }">
    <div v-if="!appIsActive">
      <h3 class="inactive-notice">Aplikacija je još u izradi<span class="pulse"></span></h3>
    </div>
    <h1 class="title layout-spacing-big">Profil</h1>

    <div class="layout-spacing">
      <h2 class="subtitle">Osobni podaci</h2>
      <ProfileInfo :name="name" :surname="surname" :email="email" />
      <section v-if="isNewsletterEnabled !== null" class="profile-newsletter">
        <h2 class="subtitle">Newsletter</h2>
        <form v-on:click="handleNewsletterChange()" v-bind:class="{ 'profile-newsletter__form': isNewsletterEnabled }">
          <span class="newsletter__checkbox">
            <input type="checkbox" name="newsletter" value="isNewsletterEnabled" />
            <span v-if="isNewsletterEnabled" class="check-mark">
              <img src="@/assets/icons/check-sign.svg" alt="checkmark" />
            </span>
          </span>
          <label for="newsletter">Želim primati newsletter</label>
        </form>
        <div class="success" v-bind:style="{ display: didNewsletterSucceedUpdate && isUpdateOver ? 'block' : 'none' }">
          Postavke newslettera su uspješno spremljene
        </div>
        <div class="error" v-bind:style="{ display: !didNewsletterSucceedUpdate && isUpdateOver ? 'block' : 'none' }">
          Postavke newslettera nisu uspješno spremljene
        </div>
      </section>

      <div class="buttons-wrapper">
        <router-link to="/" class="button-classic">
          <img class="button-classic__image" src="@/assets/app-icons/profile/web.svg" />
          <span class="button-classic__text">Povratak na web</span>
          <img class="button-classic__chevron" src="@/assets/app-icons/schedule/chevron.svg" />
        </router-link>
        <button class="button-classic" v-on:click="logout()">
          <img class="button-classic__image" src="@/assets/app-icons/profile/logout.svg" />
          <span class="button-classic__text">Odjava</span>
          <img class="button-classic__chevron" src="@/assets/app-icons/schedule/chevron.svg" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ProfileInfo from './Profile/ProfileInfo';
import { appIsActive } from '@/config';

export default {
  name: 'Profile',
  components: {
    ProfileInfo,
  },
  data() {
    return {
      name: null,
      surname: null,
      email: null,
      isNewsletterEnabled: null,
      newsletterClass: 'profile-newsletter',
      changePasswordShown: false,
      wasPasswordChangeSuccessful: false,
      didNewsletterSucceedUpdate: true,
      isUpdateOver: false,
      appIsActive,
    };
  },
  created: function() {
    this.$axios.get(`${this.$API_URL}/user/get-user-info`).then(({ data }) => {
      this.name = data.firstName;
      this.surname = data.lastName;
      this.email = data.email;
      this.isNewsletterEnabled = data.newsletterEnabled;
    });
  },
  methods: {
    handleNewsletterChange: function() {
      this.$axios
        .post(`${this.$API_URL}/user/change-newsletter`, {
          isNewsletterEnabled: !this.isNewsletterEnabled,
        })
        .then(() => {
          this.isNewsletterEnabled = !this.isNewsletterEnabled;
          this.didNewsletterSucceedUpdate = true;
          this.isUpdateOver = true;
          setTimeout(() => {
            this.isUpdateOver = false;
          }, 3000);
        })
        .catch(() => {
          this.didNewsletterSucceedUpdate = false;
          this.isUpdateOver = true;
          setTimeout(() => {
            this.isUpdateOver = false;
          }, 3000);
        });
    },
    logout: function() {
      localStorage.removeItem('token');
      this.$router.push('/');
    },
  },
};
</script>

<style scoped>
a:hover,
button:hover {
  cursor: pointer;
}

#profile {
  padding: 48px 24px 100px;
}

#profile.margin-small {
  margin-top: 60px;
}

.title {
  margin-top: 0;
  margin-bottom: 40px;
}

.subtitle {
  font-style: normal;
  font-weight: 800;
  font-size: 20px;
  line-height: 30px;
  color: #ffffff;
  margin-bottom: 24px;
}

.inactive-notice {
  color: #30cec2;
  font-weight: 800;
  font-size: 32px;
  line-height: 38px;
  margin-bottom: 62px;
}

#profile.blurred {
  filter: blur(10px);
}

.pulse {
  background-color: #30cec2;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  position: relative;
  display: inline-block;
  margin-left: 36px;
}

.pulse::after,
.pulse::before {
  content: '';
  display: block;
  position: absolute;
  border-radius: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform-origin: center center;
  animation: pulse 2s infinite;
}

.pulse::before {
  background-color: #30cec2;
  opacity: 0.6;
  transform: scale(2.5);
}

.pulse::after {
  background-color: #30cec2;
  opacity: 0.3;
  transform: scale(3.5);
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
    opacity: initial;
  }
  70% {
    tramsform: scale(1);
  }
  100% {
    tramsform: scale(0.95);
    opacity: 0;
  }
}

.profile-newsletter {
  margin-bottom: 64px;
}

#profile form > label {
  font-size: 18px;
  line-height: 146.5%;
  text-align: center;
  color: #ffffffcc;
}

#profile form > span {
  display: inline-block;
  width: 20px;
  height: 20px;
  text-align: center;
  border: 2px solid #fff;
  border-radius: 4px;
  margin-right: 10px;
  position: relative;
}

#profile form:hover,
#profile form span:hover,
#profile form input:hover,
#profile form label:hover {
  cursor: pointer;
}

.check-mark {
  position: absolute;
  font-weight: bold;
  top: -1px;
  left: 1px;
  z-index: -1;
  color: #1a3b44;
}
.check-mark img {
  width: 15px;
}

#profile form input {
  opacity: 0;
  margin: 0;
}

.buttons-wrapper {
  display: flex;
  flex-direction: column;
  max-width: 330px;
}

.button-classic {
  display: flex;
  position: relative;
  border: 0;
  flex-basis: 100%;
  align-items: center;
  padding: 16px 18px 16px 24px;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 10px;
  text-align: left;
  transition: box-shadow 0.2s ease-in-out;
}
.button-classic:not(:last-child) {
  margin-bottom: 8px;
}
.button-classic:hover {
  background-color: rgba(255, 255, 255, 0.12);
}
.button-classic__text {
  display: inline-block;
  font-family: 'Fuse V.2 Display', 'Arial', sans-serif;
  font-style: normal;
  font-size: 14px;
  line-height: 17px;
  color: #fff;
  font-weight: 300;
  margin-left: 17px;
}
.button-classic__chevron {
  margin-left: auto;
}

@media screen and (max-width: 580px) {
  #profile span > h3,
  #profile span > p,
  #profile span > a {
    font-size: 14px;
  }

  #profile form {
    display: flex;
    align-items: center;
  }

  #profile form > label {
    font-size: 14px;
    font-weight: 300;
  }

  #profile form > span {
    border-width: 1px;
    width: 14px;
    height: 14px;
  }

  .check-mark {
    font-size: 12px;
    left: 0;
    top: 0;
  }
}

@media screen and (min-width: 1023px) {
  #profile {
    padding: 160px 100px;
  }
}
</style>
